// Stillhouse view — Usage & analytics. No analytics backend yet — empty state.
import React from "react";
import { Btn } from "../brand/apo";
import { Card, PageHeader, EmptyState } from "../brand/sh";

const Scroll = ({ children }: { children: React.ReactNode }) => (
  <div style={{ flex: 1, overflow: "auto", padding: "22px 32px", display: "flex", flexDirection: "column", gap: 16 }}>{children}</div>
);

export function Reports() {
  return (
    <React.Fragment>
      <PageHeader
        crumb="INSIGHTS › REPORTS"
        title="Usage & analytics"
        sub="Session volume, utilisation and round-trip health across the fleet — the numbers behind every renewal conversation."
      >
        <Btn ghost>Last 14 days ▾</Btn>
        <Btn primary>Export</Btn>
      </PageHeader>
      <Scroll>
        <Card pad={false}>
          <EmptyState title="No analytics yet" sub="USAGE METRICS APPEAR ONCE SESSIONS ACCUMULATE" />
        </Card>
      </Scroll>
    </React.Fragment>
  );
}
